import favicon from '../../common/app/favicon'

export default {
  title: 'Vobo - your online vocabulary book for languages learning',
  metas: [
    { charset: 'utf-8' },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
    },
    {
      'http-equiv': 'x-ua-compatible',
      content: 'ie=edge',
    },
    {
      name: 'description',
      content: 'Testing platform for teachers. Let the app grade your tests.',
    },
    {
      name: 'og:image',
      content: 'https://vobo.io/assets/images/vobo-fbshare.jpg',
    },
    ...favicon.meta,
  ],
  links: favicon.link,
}



// WEBPACK FOOTER //
// ./src/browser/app/meta.js